


import React, { useEffect, useState } from 'react'
import { SelectModalPc } from '../Common/SelectModalPc'
import { LabeledValue, SelectProps } from 'antd/es/select';
import { useGetData } from '@/component/PageComponent/hooks/requst';
import { useSelectRow } from '@/component/PageComponent/Table/hooks/columns';
import { DhbFilterForm, DhbFooterProps } from '@/component/PageComponent/PageComponent';
import { TableResize } from '@/component/PageComponent/Table/TableResize';
import { Button, Col, Pagination, Row, Flex } from 'antd';
import { TableFieldSetColumn } from '@/component/Report/TableFieldSet/TableFieldSet';
import { useSelectModalList, useSelectModalListType } from '../hooks/useSelectModalList';
import { FilterProps, FilterTypes } from '../../FilterCommon/Filter';
import { requestLoading } from '@/hooks/hooksPc/useRequestLoadingPc';


type FilterParams = Partial<{
  page: number;
  pageSize: number;
  kw?: string
}>;

const initParams: FilterParams = {
  page: 1,
  pageSize: 10,
};

const DhbFooter = (
  props: DhbFooterProps & { onCancel(): void; onOk(): void },
) => {
  const {
    selectedRowKeys = [],
    onChange,
    dataSource = [],
    isAllSelect,
    total = 0,
    pageInfo,
    toggleSelectRowKeys,
  } = props;
  const { page = 1, pageSize = 10 } = pageInfo;

  return (
    <div style={{ padding: '10px' }}>
      <Row>
        <Col span={14}>
          <Pagination
            style={{ textAlign: 'left' }}
            defaultPageSize={pageSize}
            total={total}
            current={page}
            onChange={(page, pageSize) => onChange({ page: page, pageSize })}
            onShowSizeChange={(current, pageSize) =>
              onChange({ page: 1, pageSize })
            }
            showQuickJumper={false}
          />
        </Col>
        <Col span={10}>
          <div style={{ textAlign: 'right' }}>
            <Button
              onClick={() => props.onCancel()}
              style={{ margin: '0 10px' }}
            >
              取消
            </Button>
            <Button type="primary" onClick={() => props.onOk()}>
              确定
            </Button>
          </div>
        </Col>
      </Row>
    </div>
  );
};





export interface SelectListModalProps<T extends Record<string, any> = {}> extends Pick<SelectModalCommonPc<T>, 'getList' | 'listKey'> {
  onChangeValues?(values: string[], options: LabeledValue[], dataSource: any[]): void;
  onClose(): void;
  type?: 'radio' | 'checkbox';
  title?: React.ReactNode
  filterProps: Pick<FilterProps, 'filters' | 'rowFlex'>
  columns: TableFieldSetColumn<T>[]
  defaultValue?: any;
}

export const SelectListModal = <T extends Object = {}>(props: SelectListModalProps<T>) => {
  const { listKey, defaultValue } = props
  const [list, setList] = React.useState<any[]>([]);
  const [count, setCount] = React.useState<number>(0);
  const getList = async (params: FilterParams) => {
    let { list, count } = await requestLoading(props.getList({ ...params, }));
    setList(list);
    setCount(count);
  };

  let { setParams, setPageInfo, loading, pageInfo, params } = useGetData({
    getData: getList,
    defaultParams: {...initParams, ...defaultValue}
  });
  const { selectedRowKeys, isAllSelect, toggleSelectRowKeys, setSelectedRowKeys, } = useSelectRow(list, listKey);
  React.useEffect(() => {
    getList({ ...params, ...pageInfo });
  }, []);
  return (
    <Flex vertical style={{ height: '100%' }}>
      <h2 style={{ paddingLeft: '16px', margin: '16px 0 0 0' }}>{props.title}</h2>
      <DhbFilterForm
        defaultParams={{...initParams, ...defaultValue}}
        loading={loading}
        onSearch={(params) => setParams(params)}
        filterProps={props.filterProps}
      />
      <TableResize
        style={{ flex: 1, padding: '0 20px 16px 16px' }}
        rowKey={listKey}
        pagination={false}
        columns={props.columns}
        dataSource={list}
        rowSelection={{
          type: props.type || 'radio',
          selectedRowKeys: selectedRowKeys,
          onChange: (keys) => {
            setSelectedRowKeys(keys as any);
          },
        }}
        size="middle"
      />
      <DhbFooter
        selectedRowKeys={selectedRowKeys}
        dataSource={list}
        isAllSelect={isAllSelect}
        toggleSelectRowKeys={toggleSelectRowKeys}
        onChange={(pageInfo) => {
          setPageInfo(pageInfo);
        }}
        total={count}
        pageInfo={pageInfo}
        onCancel={() => {
          props.onClose();
        }}
        onOk={() => {
          props.onClose();
          let selectedRow: any[] = [];
          list.forEach((item) => {
            // let a = item[listKey];
            if (selectedRowKeys.includes(item[listKey])) {
              selectedRow.push(item);
            }
          });
          let options = selectedRow.map(item => ({ label: item.client_name, value: item.client_id }))
          props.onChangeValues?.(selectedRowKeys, options, selectedRow);
        }}
      />
    </Flex>
  );
};



export interface SelectModalCommonPc<T extends Object> extends Pick<useSelectModalListType<any>, "componentKey" | "listKey"> {
  SelectProps?: Omit<SelectProps, 'onChange'>
  SelectListModalProps: Omit<SelectListModalProps<T>, 'onClose' | 'onChangeValues'>
  value: any,
  defaultValue?: any; 
  getList(params: {}): Promise<{ list: Array<any>, count: number }>
  getDetail?(params: {}): Promise<any>
  onChange?(value: any, option: any): void;
}

export function SelectModalCommonPc<T extends Object>(props: SelectModalCommonPc<T>) {
  const { value, SelectProps, SelectListModalProps, defaultValue, getDetail, ...rest } = props
  // const [goodsList, setListList] = useState<ListItem[]>([])
  const { list, setList: setListList, prependList ,isFetchCache} = useSelectModalList<any>({ listKey: props.listKey, componentKey: props.componentKey, value: value })

  const [isFirstFocus, setIsFirstFocus] = useState<boolean>(true)
  const [loading, setLoading] = useState<boolean>(false)
  // const [values, setValues] = useState<string | string[]>(value)
  const filterList = async (params: FilterParams) => {
    setLoading(true)
    const resData = await props.getList({ ...params })
    setLoading(false)
    setListList(resData.list || [])
  }

  const filterDetail = async (params: { ids: string[]}) => {
    const resData = await props.getDetail?.({...params});
    const option = resData ? resData : [];
    setListList(option)
  }

  useEffect(() => {
    if(isFetchCache){
      if (value && !list.length) {
        filterDetail({
          ids: value,
        });
      }
    }
  }, [isFetchCache])

  let onChange = (value: any, option: any) => {
    props.onChange?.(value, option)
  };
  const focus = () => {
    if (isFirstFocus) {
      if (!list.length) {
        setLoading(true)
        filterList({
          page: 1,
          pageSize: 10,
        })
      }
      setIsFirstFocus(false)
    }

  }
  return (
    <div>
      <SelectModalPc
        value={value}
        placeholder={SelectProps?.placeholder || '选择'}
        options={list.map(item => ({ label: item.label, value: item.value }))}
        onFocus={focus}
        loading={loading}
        onChange={(value, option) => {
          onChange?.(value, option);
        }}
        onSearch={(kw) => {
          filterList({
            page: 1,
            pageSize: 10,
            kw: kw,
          })
        }}
        {...SelectProps}
        MoreComponent={({ onClose }) => (
          <SelectListModal<T>
            {...SelectListModalProps}
            getList={SelectListModalProps.getList || props.getList}
            onClose={onClose}
            onChangeValues={(values, option, sources) => {
              prependList(sources)
              onChange(values, option)
            }}
            defaultValue={defaultValue}
          />
        )}
      />
    </div>

  )
}